import React from 'react';
export function ButtonMaxWidthElement(props) {
    const { children, maxWidth } = props;
    if (!maxWidth) {
        return children;
    }
    return React.createElement("div", { style: { maxWidth } }, children);
}
//# sourceMappingURL=button-max-width-element.js.map